<template>
        <button class="btn btn-default" @click="setAsDefault()" :disabled="isDefaultMethod || isSubmitted">
            <i class="fa fa-spinner fa-spin" v-if="isSubmitted"></i>
            <span v-else>
              <i class="fa fa-check text-success" v-if="isDefaultMethod"></i>
              <i class="fa fa-minus text-muted" v-else></i>
            </span>
        </button>
</template>
<script>
    export default {

        props: {
            method: {
                type: Object,
                required: true
            },
            default: {
                type: Object,
                required: true
            },
            user: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                isSubmitted: false,
            }
        },

        methods: {
            setAsDefault() {
                this.isSubmitted = true;
                axios.patch(`/billing/${this.user.slug}/payment-methods/${this.method.id}`).then(response => {
                    this.refreshPage();
                }).catch(error => {
                    this.isSubmitted = false;
                })
            }
        },

        computed: {
            isDefaultMethod() {
                if (!this.default) return false;
                return this.method.id == this.default.id;
            }
        }
    }
</script>
